<template>
    <div class="card-button">
        <div v-for="(input,index) in inputs" class="card actionable" @click="select(index)"
             v-bind:class="[ selectedValue == input.value ? 'green selected' : '', selectedValue == false ? '' : (selectedValue == input.value ? '' : 'hide')  ]">
            <div class="card-wrap ">
                <div class="flex-center" style="font-size: 18px;">
                    <div class="flex-center">
                        <div v-if="input.image != undefined" style="margin-right:10px;">
                            <img v-bind:src="input.image" width="50" />
                        </div>
                        <div v-html="input.title"></div>
                    </div>
                    <div class="flex-filler"></div>
                    <div class="txt green-secondary handle" v-bind:class="[ selectedValue == input.value ? 'close' : '']">
                        <span class="material-icons" v-html="selectedValue == input.value ? 'close' : 'chevron_right'"></span>
                    </div>
                </div>
            </div>
        </div>
        <input type="hidden" v-bind:value="value" v-bind:name="name" />
    </div>
</template>

<script>
    module.exports = {
        created:function() {
            if(this.selected != '') {
                this.selectedValue = this.selected;
            }
        },
        data:function() {
            return {
                selectedValue:false,
                value:''
            }
        },
        props: {
            title:{type:String,default:''},
            inputs:{type:Array,default:[]},
            name:{type:String,default:'selection'},
            toggle:{type:String,default:''},
            selected:{type:String,default:''}
        },
        methods: {
            select:function(index) {
                $(this.toggle).toggle();
                this.toggleContainers(index);
                if(this.selectedValue) {
                    this.selectedValue = false;
                    this.value = '';
                } else {
                    this.value = this.inputs[index].value;
                    this.selectedValue = this.value;
                }
            },
            toggleContainers:function(index) {
                $.each(this.inputs,function(i,value) {
                    if(value.toggle != undefined) {
                        $(value.toggle).hide();
                        if(i == index) {
                            console.log(i);
                            console.log(value.toggle);
                            $(value.toggle).show();
                        }
                    }
                }.bind(this));
            }
        },
        mounted:function() {
            $.each(this.inputs,function(index,value) {
                if(this.selectedValue == value.value) {
                    this.value = value.value;
                    this.selectedValue = this.value;
                    this.toggleContainers(index);
                }
            }.bind(this));
        }
    }
</script>
